import './App.css';

function Feb24() {
    return (
        <>
        <div className='blog-post'>
        <div className='datestyle h3'>Feb24th</div>
            <p>I was chatting with a data eng I work with about the importance of a 'deploy song'. A dev I used to work with shared this wisdom with me too ha!</p>
            <p>Something that hits when you click "DEPLOY".  Boost your heart rate, feel cool about wrapping a promotion to Prod. </p>
            <p>What's your promote code track?</p>
        <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/PhSsdQN4rZc" 
            title="YouTube video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            >
       </iframe>
         
        </div>
        </>
    );
}

export default Feb24;